var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"content"},[_vm._v("\n    服务器种子： "),_c('span',[_vm._v(_vm._s(_vm.seed))]),_vm._v(" （刷新查看最新种子）\n  ")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.setrefreshSeeds}},[_vm._v("刷新")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }